import { createFileRoute, Outlet } from '@tanstack/react-router'
import { HiddenSearchParams } from './-src/types';
import AppBar from '../../../shared/components/app-bar';
import PacificoIcon from '../../../shared/components/icons/PacificoIcon';


export const Route = createFileRoute('/_with-appbar/otp/')({
  loaderDeps({search}) {
    const { documentNumber, documentType } = search as HiddenSearchParams;

    return {
      documentNumber,
      documentType,
    }
  },
  component: ()=>{
    return<>
       <AppBar logo={<PacificoIcon />} />
       <Outlet />
    </>
  }
})
